import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "HOME", href: "/#home" },
  { label: "ABOUT APP", href: "/#about" },
  { label: "FEATURES", href: "/#features" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar-container"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F0EAFD]/75 border-b border-[#0F2C5A]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="/"
          data-testid="navbar-logo"
          className="flex items-center gap-2 group"
          aria-label="Qontri"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_app-showcase-256/artifacts/sfp2m0n8_Untitled%20design%20%2815%29.png"
            alt="Qontri"
            className="h-16 md:h-20 w-auto rounded-xl transition-transform duration-300 group-hover:-rotate-2 scale-[1.35] origin-left"
            style={{ mixBlendMode: "multiply" }}
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="relative text-[13px] font-semibold tracking-[0.18em] text-[#0F2C5A] hover:text-[#3056F5] transition-colors group"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#3056F5] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="#download"
          data-testid="navbar-cta"
          className="hidden md:inline-flex items-center gap-2 bg-[#0F2C5A] hover:bg-[#3056F5] text-white text-[12px] font-bold tracking-[0.2em] px-5 py-3 rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#3056F5]/30"
        >
          GET APP
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#3056F5]" />
        </a>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden w-10 h-10 rounded-full bg-[#0F2C5A] text-white flex items-center justify-center"
          aria-label="menu"
        >
          <span className="block w-4 h-[2px] bg-white relative before:absolute before:content-[''] before:w-4 before:h-[2px] before:bg-white before:-top-1.5 after:absolute after:content-[''] after:w-4 after:h-[2px] after:bg-white after:top-1.5" />
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-[#F0EAFD]/95 backdrop-blur-xl border-t border-[#0F2C5A]/10"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#0F2C5A] font-display text-2xl"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center bg-[#0F2C5A] text-white font-bold tracking-widest px-5 py-3 rounded-full"
            >
              GET APP
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
